import isSessionStorageEnabled from "./isSessionStorageEnabled";

export const getSessionStorage = (key: string) => {
  if (isSessionStorageEnabled()) {
    const cachedProducts = sessionStorage.getItem(`syf-${key.toLowerCase()}`);
    return cachedProducts;
  }
};

export const setSessionStorage = (key: string, value: string) => {
  if (isSessionStorageEnabled()) {
    sessionStorage.setItem(`syf-${key.toLowerCase()}`, value);
    return;
  }
};
